import { ReactNode } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import "./ProfileSidebarSection.scss";

interface Props {
    title: ReactNode;
    children: ReactNode;
}

/** Titled block inside `ProfileSidebar`. Layout (gaps) comes from the consumer's `className`. */
const ProfileSidebarSection: FCX<Props> = ({ title, children, className, style, testId }) => (
    <div className={className} style={style} data-testid={testId}>
        <div className="ProfileSidebarSection__title">{title}</div>
        {children}
    </div>
);

export default ProfileSidebarSection;
